import React, { useMemo } from 'react'
import { observer } from 'mobx-react'
import { cartMobx, restaurantConfig } from 'restaurant'
import { checkoutMobx } from '@mobxStore'
import { flatten, pick } from '@dt/fe-utils/dist/lodash'
import { localStore } from '@utils'
import DiningNumberPickController from '@ctrls/diningNumberPickController'
import { Icon } from 'components'
import './index.scss'

const CartActions: React.FC = () => {
  // 就餐人数
  const handleShowPeronPick = () => {
    DiningNumberPickController.showPicker()
  }

  // 全部打包
  const handleAllPack = () => {
    cartMobx.setAllCartItemPackCheck()
    if (!localStore.get('packed')) {
      localStore.set('packed', true, 3000)
    }
  }

  // 打包
  const handlePack = () => {
    cartMobx.setOrderMerge(false)
    cartMobx.setNeedPack(true)
  }

  // 有能打包餐品
  const isCanTogoCnt = useMemo(() => {
    const cnt = cartMobx.viewCartItems.filter(cartItem => cartItem.isCanTogo)?.length
    const swapCnt = flatten(pick(cartMobx.viewCartItems, 'swapBuyProducts')).filter(cartItem => cartItem.isCanTogo)?.length
    const fullNFreeCnt = flatten(pick(cartMobx.viewCartItems, 'fullItemNFreeProducts')).filter(cartItem => cartItem.isCanTogo)?.length
    return cnt + swapCnt + fullNFreeCnt
  }, [cartMobx.viewCartItems])

  return (
    cartMobx.needPack ? (
      <div className='cart-actions in-packed'>
        <div className='cart-action-tip'>
          {
            isCanTogoCnt ? (
              <div className='action-btn-wrapper'>
                <button data-cypid='cartActionAllPack' onClick={handleAllPack}>{cartMobx.isPackCheckAll ? i18n.t('common.cancel') : i18n.t('newCart.allpack')}</button>
              </div>
            ) : null
          }
          <h4>{i18n.t('newCart.youAreInPack')}</h4>
        </div>
      </div>
    ) : (restaurantConfig.codeType !== 'brand' || cartMobx.info.eatType === 'dinein') && checkoutMobx.dineinCanTogo ? (
      <div className='cart-actions'>
        <div className='cart-action-item' onClick={handleShowPeronPick} data-cypid='cartActionPickPerson'>
          <Icon name='jiucanrenshu' />
          <span className='action-cnt'>x{cartMobx.info.person + (cartMobx.info.kids || 0)}</span>
        </div>
        <div className='cart-action-item' onClick={handlePack} data-cypid='cartActionPack'>
          <Icon name='dabao' />
          {!!cartMobx.packedCnt && (
            <span className='action-cnt'>
              x{cartMobx.packedCnt}
            </span>
          )}
        </div>
      </div>
    ) : null
  )
}

export default observer(CartActions)
